import { useMemo } from "react";
import apiOSS from "../../../api/apiOSS";
import { createTcmApi, TcmApi } from "./api";

export function useTcmApi(): TcmApi {
  const tcmApi = useMemo(() => createTcmApi(apiOSS), []);
  return tcmApi;
}
